import axios from "./axiosClient";
import { fetchData } from "./fetch";

export const login = async (data) => {
  try {
    const { data: responseData } = await axios.post('/auth/login', data);
    return responseData;
  } catch (err) {
    throw err;
  }
}

export const getUser = async () => {
  try {
    const { data: responseData } = await axios.get('/auth/user');
    return responseData;
  } catch (err) {
    throw err;
  }
}


export const updateUserData = data => fetchData('PUT', '/auth/user', data);

export const updateUserPassword = data => fetchData('POST', '/auth/user/password', data);

export const inviteUser = data => fetchData('POST', '/auth/user/invite', data);

export const completeRegistration = data => fetchData('POST', '/auth/user/invite/complete', data);
